import { WithLayoutType } from '@sbercloud/uikit-product-utils';

import { BlogRichText } from '../BlogRichText';
import styles from './styles.module.scss';

type HighlightProps = WithLayoutType<{
  richText: string;
}>;

export function Highlight(props: HighlightProps) {
  const { layoutType, richText } = props;

  return (
    <div className={styles.highlight} data-test-id="highlight">
      <BlogRichText layoutType={layoutType} richText={richText} />
    </div>
  );
}
